import {axiosPartnerPlatformInstance} from "../../ServerApiManager";
import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";

type Variables = {
  partnerCode?: string;
};
type Data = {};
export const getHasOfActionRequired = async (variables: Variables): Promise<boolean> => {
  const result = await axiosPartnerPlatformInstance.get<Data, AxiosResponse<boolean>>(`/disputes/action-required`, {});
  return result.data;
};

export const useGetHasOfActionRequired = (
  variables: Variables,
  options?: BaseQueryOptions<boolean, Variables>
): BaseUseQueryResult<boolean> => {
  const queryKey = ["partner-disputes", "action_required", variables.partnerCode];
  return useBaseQuery<boolean, Variables>(queryKey, getHasOfActionRequired, variables, options);
};
